// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-1yoyH","btnDetail":"index-btnDetail-2GXZM"};